interface  KeyValueModel {key: string, value: any}
interface  ObjectModel {[key: string]: any}

const mapPathKeyToObject = (object: KeyValueModel, targetObject: ObjectModel) => {
	const path = object.key.split('.');
	let currentLevel = targetObject;
	path.forEach((key, index) => {
		if (index === path.length - 1) {
			currentLevel[key] = object.value;
		}
		else if (!currentLevel[key]) {
			currentLevel[key] = index === path.length - 1 ? object.value : {
			};
		}
		currentLevel = currentLevel[key];
	});
};

/**
 * A function for re-mapping objects made for updating to indexedDB,
 * making them into structured objects from dot paths.
 * @param object
 */
export const getHttpReadyObject = (object: {[key: string]: any}) => {
	/**
	 * In case the object is undefined or null
	 */
	if (!object) {
		return object;
	}

	const result: {[key: string]: any} = {
	};
	const pathKeys: {key: string, value: any}[] = [];

	const isPathKey = (key: string) => key.split('.')?.length > 1;

	Object.keys(object)
		.forEach(key => {
			const value = object[key];
			if (isPathKey(key)) {
				pathKeys.push({
					key, value,
				});
			}
			else {
				result[key] = value;
			}
		});

	pathKeys.forEach(o => mapPathKeyToObject(o, result));

	return result;
};